module.exports = __webpack_public_path__ + "static/media/data.567bf75c.svg";